import { ItemDTO, ItemType } from 'src/models/dto/items/ItemDTO'
import {
    defaultSingleSelectCheckboxItemDTO,
    SingleSelectCheckboxItemDTO,
} from 'src/models/dto/items/SingleSelectCheckboxItemDTO'
import { Locale } from 'src/models/dto/Locale'
import { factories, ITEM_ENTITY_STORE_SELECTOR } from '../ItemEntityService'
import { Stores } from './../../Store'

const itemType = ItemType.SingleSelectCheckbox

export class SingleSelectCheckboxHandler {
    static init() {
        // add the create function to the set of factories available in ItemEntityService
        factories.set(itemType, () => SingleSelectCheckboxHandler.create())
    }

    private static store() {
        return Stores.get<SingleSelectCheckboxItemDTO, ItemDTO>(ITEM_ENTITY_STORE_SELECTOR)
    }

    static create(): SingleSelectCheckboxItemDTO {
        return defaultSingleSelectCheckboxItemDTO()
    }

    private static assign(id: string, obj: Partial<SingleSelectCheckboxItemDTO>) {
        this.store().assign(id, obj)
    }

    static updateLabel(id: string, label: string) {
        this.assign(id, { label })
    }

    static updateOptional(id: string, optional: boolean) {
        this.assign(id, { optional })
    }

    static updatePreserveOrder(id: string, preserveOrder: boolean) {
        this.assign(id, { preserveOrder })
    }

    static updateStatement(id: string, locale: Locale, nextValue: string) {
        this.store().produce(id, (entity) => {
            entity.statementI18N[locale] = nextValue
        })
    }
}
